import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { EditorLayout } from "../../../../insa-models/editor-layout.model";
import { FieldGroupDefinition } from "../models/FieldGroup/FieldGroup";
import { EditorLayoutService } from "../services/editor-layout.service";
import { makeSortedFields } from "../utilities";

@Component({
  selector: 'editor-wizard',
  styles: [`
  .modal-body.modal-body {
    padding: 0;
    max-height: 70vh;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .grid-container {
    display: flex;
    flex-wrap: wrap;
    padding: 0 1.5rem 1.5rem 0;
  }
  .field-column {
    margin: 1.5rem 0 0 1.5rem;
    padding: 1rem;
    overflow: hidden;
    max-width: 500px;
    width: 30%;
    min-width: 250px;
    flex-grow: 1;
    flex-shrink: 1;
    background: #f0f0f0;
  }
  .field-column h3 {
    margin: 0 0 0.5rem 0;
    padding: 0.5rem;
    background: #e0e0e0;
    overflow: hidden:
    text-overflow: ellipsis;
  }
  .field-row {
    display: flex;
    align-items: center;
    overflow: hidden;
    padding: 0 0.5rem;
  }
  input[type=checkbox], input[type=radio] {
    margin: 0 4px 0px 0px;
  }
  .field-item__label {
    flex-grow: 1;
    padding-right: 0.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
  }
  .reorder-btn {
    font-size: 0.8rem;
  }
  `],
  template: `<div
    id="editor-wizard-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content modal-loading">
        <div class="modal-header">
          <h3 class="modal-title">Editor wizard</h3>
          <button
            (click)="closeModal()"
            type="button"
            class="close"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-header" style="display: flex; align-items: center; flex-grow: 1; flex-wrap: wrap; align-items: stretch;">
          <ng-container *ngIf="layouts && !newLayout">
            <div style="display: flex; flex-grow: 1; justify-content: flex-start; align-items: baseline">
              <div style="display: flex; align-items: center">Layout</div>
              <select *ngIf="layouts && layouts.length" (change)="selectLayout($event.target.value)" class="btn btn-default" style="margin-left: 0.5rem; max-width: 7rem;">
                <option [selected]="!selectedLayout" value="" disabled hidden>...</option>
                <option *ngFor="let layout of layouts" [selected]="selectedLayout && selectedLayout.name === layout.name" value="{{layout.name}}" [value]="layout.name" >{{ layout.name || 'unnamed' }}</ option>
              </select>
              <span *ngIf="selectedLayout && selectedLayout.isClientDefault" style="margin: 0 1rem; align-self: center; color: blue;" >Client default</span>
              <button style="margin-left: 0.5rem;" (click)="createNewLayout()" type="button" class="btn btn-primary">Save as</button>
            </div>
            <div style="display: flex; flex-grow: 1; justify-content: flex-end; align-items: baseline">
              <button *ngIf="selectedLayout" (click)="deleteSelectedLayout()" style="margin-left: 0.5rem;" type="button" class="btn btn-danger">Delete</button>
            </div>
          </ng-container>
          <ng-container *ngIf="layouts && newLayout">
            <input [(ngModel)]="newLayout.name" class="input" style="margin-top: 0.5rem;" type="text" placeholder="New layout name" style="margin-left: 0.5rem;" />
            <label for="isClientDefault" style="margin: 0 0.5rem 0 1rem; align-self: center;">Client default</label><input id="isCustomerDefault" [(ngModel)]="newLayout.isClientDefault" type="checkbox" style="margin: 0 1rem 0 0; align-self: center;" />
            <button (click)="saveLayout()" style="margin-left: 0.5rem;" type="button" class="btn btn-primary">Save</button>
            <button (click)="cancelNewLayout()" style="margin-left: 0.5rem;" type="button" class="btn btn-default">Cancel</button>
            </ng-container>
        </div>
      <div class="modal-body">
        <div class="grid-container">
            <ng-container *ngFor="let group of currWizardOptions">
                <div class="field-column">
                    <h3>{{ group.label || '&nbsp;' }}</h3>
                    <ng-container *ngFor="let field of group.fields">
                      <div class="field-row">
                        <input [disabled]="field.isHidden" [checked]="!field.isManuallyHidden && !field.hidden" [id]="field.key" name="{{ field.key }}" type="checkbox" (change)="change(group.name, field.key)" />
                        <label class="field-item__label" [attr.for]="field.key" style="user-select: none;">{{ field.label }}</label>
                        <button
                          [style.visibility]="(field.isHidden) ? 'hidden' : 'visible'"
                          (click)="reorder(group.name, field.key, 1)"
                          class="reorder-btn btn btn-sm btn-default"
                          type="button"
                        >
                        ▼
                        </button>
                        <button
                          [style.visibility]="(field.isHidden) ? 'hidden' : 'visible'"
                          (click)="reorder(group.name, field.key, -1)"
                          class="reorder-btn btn btn-sm btn-default"
                          type="button"
                        >
                        ▲
                        </button>
                      </div>
                    </ng-container>
                </div>
            </ng-container>
            </div>
        </div>
        <div class="modal-footer">
          <button
            (click)="closeModal()"
            type="button"
            class="btn btn-secondary"
          >
            Close
          </button>
          <button
            (click)="apply()"
            type="button"
            class="btn btn-primary"
          >
            Apply
          </button>
        </div>
    </div>
  </div>`
})
export class EditorWizardComponent implements OnChanges, OnInit {
  @Input() isVisible: boolean = false;
  @Input() metadataName: string;
  @Input() fieldGroups: FieldGroupDefinition[];
  @Input() form: FormGroup;

  @Output() onCloseModal = new EventEmitter();
  @Output() onApplyEditorSettings = new EventEmitter();

  layouts: any[] = [];
  selectedLayout: any;
  currEditorOptions: FieldGroupDefinition[];
  currWizardOptions: FieldGroupDefinition[];
  newLayout: any;

  constructor(private _editorLayoutService: EditorLayoutService) { }

  apply() {
    this.onApplyEditorSettings.emit(JSON.parse(JSON.stringify(this.currWizardOptions)));
    this.closeModal();
  }

  createNewLayout() {
    this.newLayout = {
      name: this.selectedLayout ? this.selectedLayout.name : '',
      isClientDefault: this.selectedLayout ? this.selectedLayout.isClientDefault : false,
      options: this.currWizardOptions
    }
  }

  cancelNewLayout() {
    this.newLayout = null;
  }

  selectLayout(layoutName) {
    this.selectedLayout = this.layouts.find(t => t.name === layoutName);
    this.selectedLayout.options.forEach(g => ({ ...g, fields: makeSortedFields(g.fields) }))
    this.currWizardOptions = JSON.parse(JSON.stringify(this.selectedLayout.options));
    this.newLayout = null;
  }

  deleteSelectedLayout() {
    kendo.ui.progress($(".modal-loading"), true);
    this._editorLayoutService.deleteLayout(this.metadataName, this.selectedLayout.name).subscribe(() => {
      this._editorLayoutService.readLayouts(this.metadataName).subscribe(customLayouts => {
        this.layouts = customLayouts && customLayouts.length ? this.customLayoutsToLayouts(customLayouts) : [];
        kendo.ui.progress($(".modal-loading"), false);
        this.selectedLayout = null
      })
    })
  }

  saveLayout() {
    kendo.ui.progress($(".modal-loading"), true);
    let saveAction;
    if (this.layouts.find(lyt => lyt.name === this.newLayout.name)) {
      saveAction = this._editorLayoutService.updateLayout
    } else {
      saveAction = this._editorLayoutService.createLayout
    }

    saveAction(this.metadataName, this.toLayoutDTO(this.newLayout)).subscribe(() => {
      this._editorLayoutService.readLayouts(this.metadataName).subscribe(customLayouts => {
        kendo.ui.progress($(".modal-loading"), false);
        this.layouts = this.customLayoutsToLayouts(customLayouts);
        this.selectLayout(this.newLayout.name)
        this.newLayout = null;
      })
    })
  }

  change(groupName: string, fieldKey: string) {
    const field = this.currWizardOptions.find(
      gs => gs.name === groupName
    ).fields.find(
      fs => fs.key === fieldKey
    )
    field.isManuallyHidden = !field.isManuallyHidden
  }

  reorder(groupName: string, fieldKey: string, direction: number) {
    const group = this.currWizardOptions.find(
      gs => gs.name === groupName
    )

    const field = group.fields.find(
      fs => fs.key === fieldKey
    )

    const index = group.fields.indexOf(field);

    const destinationIndex = index + direction;
    if (!(destinationIndex < 0) && !(destinationIndex > group.fields.length - 1)) {
      const field1 = group.fields[index]
      const field2 = group.fields[destinationIndex]
      const order1 = field1.customOrder || field1.order
      const order2 = field2.customOrder || field2.order
      field1.customOrder = order2
      field2.customOrder = order1
      group.fields = makeSortedFields(group.fields)
    }
  }

  closeModal() {
    this.onCloseModal.emit();
  }

  private toLayoutDTO(layout: any): EditorLayout {
    return {
      name: layout.name,
      isClientDefault: layout.isClientDefault,
      options: layout.options.map((g) => ({
        name: g.name,
        fields: g.fields.map(f => ({
          key: f.key,
          customOrder: f.customOrder,
          isManuallyHidden: f.isManuallyHidden
        }))
      }))
    }
  }

  private customLayoutsToLayouts(customLayouts) {
    return customLayouts.map(cl => ({
      name: cl.name,
      isClientDefault: cl.isClientDefault,
      options: cl.options.map(cfg => {
        const fg = this.fieldGroups.find(fg => fg.name === cfg.name)
        return {
          name: fg.name,
          label: fg.label,
          isVisible: typeof fg.isVisible === 'function' ? fg.isVisible(this.form) : fg.isVisible,
          fields: fg.fields.map(f => {
            const cf = cfg.fields.find(cf => cf.key === f.key);
            return {
              ...f,
              isManuallyHidden: cf.isManuallyHidden,
              customOrder: cf.customOrder
            }
          })
        }
      })
    }))
  }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    if (changes.isVisible) {
      if (this.isVisible) {
        this.currEditorOptions = JSON.parse(JSON.stringify(this.fieldGroups)).map(fg => ({
          ...fg,
          isVisible: typeof fg.isVisible === 'function' ? fg.isVisible(this.form) : fg.isVisible
        }))
        this.currWizardOptions = JSON.parse(JSON.stringify(this.currEditorOptions));
        kendo.ui.progress($(".modal-loading"), true);
        this._editorLayoutService.readLayouts(this.metadataName).subscribe(
          (customLayouts) => {
            this.layouts = customLayouts && customLayouts.length ? this.customLayoutsToLayouts(customLayouts) : [];
            this.selectedLayout = null;
            kendo.ui.progress($(".modal-loading"), false);
          }
        )
        $('#editor-wizard-modal').modal('show');
      } else {
        $('#editor-wizard-modal').modal('hide');
      }
    }
  }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/components/editor-wizard.component.ts